import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["canvas", "copyStatus"];
    static values = { url: String };

    declare readonly canvasTarget: HTMLCanvasElement;
    declare readonly copyStatusTarget: HTMLElement;
    declare readonly hasCanvasTarget: boolean;
    declare readonly hasCopyStatusTarget: boolean;
    declare readonly urlValue: string;

    async connect(): Promise<void> {
        if (!this.hasCanvasTarget || !this.urlValue) return;

        const moduleUrl = "/static/qr-code.js";
        const { default: QRCode } = await import(moduleUrl) as { default: typeof import("qrcode") };
        if (!this.element.isConnected) return;
        void QRCode.toCanvas(this.canvasTarget, this.urlValue, {
            width: 152,
            margin: 1,
            errorCorrectionLevel: "M",
        });
    }

    async copy(): Promise<void> {
        try {
            await navigator.clipboard.writeText(this.urlValue);
            if (this.hasCopyStatusTarget) this.copyStatusTarget.textContent = "Lien copié.";
        } catch {
            if (this.hasCopyStatusTarget) this.copyStatusTarget.textContent = "Sélectionnez le lien pour le copier.";
        }
    }

    confirm(event: SubmitEvent): void {
        const form = event.currentTarget as HTMLFormElement;
        const message = form.dataset.confirmMessage;
        if (message && !window.confirm(message)) event.preventDefault();
    }
}
